export const DASHBOARD_URL = "https://dashboard.thinkwire.ai";
export const SUPPORT_EMAIL = "support@thinkwire.ai";
